import { FormattedMessage } from 'react-intl';

import type { Step } from '@/store/bulkOrder/state.ts';

interface BulkStepperProps {
  step: Step;
  hasError: boolean;
}

export const BulkOrderStepper: React.FunctionComponent<BulkStepperProps> = ({ hasError, step }) => {
  return (
    <ul className={`stepper${hasError ? ' text-danger' : ''}`}>
      {[1, 2, 3].map((s) => {
        const isPastStep = s < step || (s === 3 && step === 3);
        return (
          <li key={s} className={`stepper-step ${isPastStep ? 'fill' : step === s ? 'current' : 'inactive'}`}>
            <div className="stepper-step-inner">
              <div className="stepper-indicator">
                <i className="icon">
                  {s === 3 && hasError ? 'close' : isPastStep ? 'check' : step === s ? 'fiber_manual_record' : ''}
                </i>
              </div>
            </div>
            <span className="stepper-label">
              <FormattedMessage id={`bulkOrder.step${s as 1 | 2 | 3}`} />
            </span>
          </li>
        );
      })}
    </ul>
  );
};
